import Sounds from "./../../app/src/main/assets/*.mp3";
import Icons from "./../assets/*.svg";

export { Sounds, Icons };
